<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Editar Receita Plano</h6>
        <i class="bi bi-x-circle close-icon" @click="cancel"></i>
      </div>
      <div class="spacer"></div>

      <!-- Dados do Registro (readonly) -->
      <div class="modal-content">
        <h5 class="section-title">
        <span v-if="registro.plano_contas === 'Mensalidade'" class="text-success">
            Mensalidade
        </span>
        <span v-else-if="registro.plano_contas === 'Matrícula'" class="text-primary">
            Matrícula
        </span>
        </h5>
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label>Aluno:</label>
              <input type="text" :value="`${registro.alunoNome} (Matrícula ${registro.matriculaId})`" class="form-control" disabled />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Data de Vencimento:</label>
              <input type="date" :value="registro.dataVencimento" class="form-control" disabled />
            </div>
          </div>
          <!-- Valor -->
          <div class="col-md-3">
            <div class="form-group">
              <label for="valor">Valor:</label>
              <div class="input-group">
                <input
                  id="valor"
                  type="text"
                  class="form-control"
                  :value="editingValor"
                  @blur="handleBlurValor"
                  @input="e => editingValor = e.target.value"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Edição em lote (minimalista) -->
        <div
          v-if="showLoteBox"
          :class="['lote-card', { 'lote-card--active': aplicarTodosPendentes }]"
        >
          <!-- Header -->
          <div class="lote-header">
            <div class="lote-title">Edição em lote</div>
            <span class="lote-badge">{{ pendentesTotal }} parcelas pendentes para essa matrícula</span>
          </div>

          <div class="lote-body">
            <!-- Coluna esquerda -->
            <div class="lote-left">
              <div class="lote-check">
                <input
                  class="form-check-input lote-checkbox"
                  type="checkbox"
                  id="aplicarTodosPendentes"
                  v-model="aplicarTodosPendentes"
                />
                <label class="lote-main-label" for="aplicarTodosPendentes">
                  Aplicar a todos os pendentes desta matrícula
                </label>
              </div>

              <div
                v-if="aplicarTodosPendentes && isCartaoCredito(formData.formaPagamentoId)"
                class="lote-subtext"
              >
                Digite a data do <strong>PAGAMENTO</strong>  (data que o cliente pagou).
              </div>

              <!-- Aplicar valor também
              <div v-if="aplicarTodosPendentes && valorFoiAlterado" class="form-check lote-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="aplicarValorTambem"
                  v-model="aplicarValorTambem"
                />
                <label class="form-check-label" for="aplicarValorTambem">
                  Aplicar valor também
                </label>
              </div> -->

              <!-- Aviso
              <div
                v-if="aplicarTodosPendentes && valorFoiAlterado && !aplicarValorTambem"
                class="lote-warn"
              >
                ⚠️ Valor alterado não será aplicado ao lote. Marque <strong>“Aplicar valor também”</strong>.
              </div> -->
            </div>

            <!-- Coluna direita: prévia
            <div
              v-if="aplicarTodosPendentes && isCartaoCredito(formData.formaPagamentoId) && previewSequencial.length"
              class="lote-right"
            >
              <div class="lote-preview-title">Prévia (3 primeiros)</div>

              <div class="lote-preview-grid">
                <div class="lote-preview-header">#</div>
                <div class="lote-preview-header">Pagamento</div>
                <div class="lote-preview-header">Recebimento</div>

                <template v-for="p in previewSequencial" :key="p.idx">
                  <div class="lote-preview-cell lote-preview-idx">{{ p.idx }}ª</div>
                  <div class="lote-preview-cell">{{ p.pag }}</div>
                  <div class="lote-preview-cell">{{ p.rec || '—' }}</div>
                </template>
              </div>
            </div> -->
          </div>

          <!-- Aplicar valor também (mesmo layout do lote-check principal) -->
          <div v-if="aplicarTodosPendentes && valorFoiAlterado" class="lote-check mt-2">
            <input
              class="form-check-input lote-checkbox"
              type="checkbox"
              id="aplicarValorTambem"
              v-model="aplicarValorTambem"
            />
            <label class="lote-main-label" for="aplicarValorTambem">
              Aplicar valor também
            </label>
          </div>

          <!-- Aviso (somente quando valor foi alterado mas não aplicará ao lote) -->
          <div
            v-if="aplicarTodosPendentes && valorFoiAlterado && !aplicarValorTambem"
            class="lote-warn"
          >
            ⚠️ Valor alterado não será aplicado ao lote. Se quiser que seja aplicado marque <strong>“Aplicar valor também”</strong>.
          </div>
        </div>

        <h5 class="section-title">Editar Dados</h5>
        <div class="row mb-3">
          <!-- Forma de Pagamento -->
          <div class="col-md-4">
            <div class="form-group">
              <label for="forma_pagamento">Forma de Pagamento:</label>
                <select id="forma_pagamento" v-model.number="formData.formaPagamentoId" class="form-control">
                <option value="">Selecione</option>
                <option v-for="f in formas" :key="f.id" :value="f.id">{{ f.nome }}</option>
              </select>
            </div>
          </div>
          <!-- Campos Cheque Condicionais -->
          <div v-if="isCheque(formData.formaPagamentoId)" class="col-md-2">
            <div class="form-group">
              <label for="banco_numero">Banco nº:</label>
              <input type="text" id="banco_numero" v-model="formData.bancoNumero" class="form-control" />
            </div>
          </div>
          <div v-if="isCheque(formData.formaPagamentoId)" class="col-md-2">
            <div class="form-group">
              <label for="agencia">Agência:</label>
              <input type="text" id="agencia" v-model="formData.agencia" class="form-control" />
            </div>
          </div>
          <div v-if="isCheque(formData.formaPagamentoId)" class="col-md-2">
            <div class="form-group">
              <label for="cheque_numero">Cheque nº:</label>
              <input type="text" id="cheque_numero" v-model="formData.chequeNumero" class="form-control" />
            </div>
          </div>
          <!-- Data de Pagamento -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="data_pagamento">Pagamento:</label>
              <input
                type="date"
                id="data_pagamento"
                v-model="formData.dataPagamento"
                :disabled="isAInformar(formData.formaPagamentoId)"
                class="form-control"
              />
            </div>
          </div>
          <!-- Data de Recebimento -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="data_recebimento">Recebimento:</label>
              <input
                type="date"
                id="data_recebimento"
                v-model="formData.dataRecebimento"
                :disabled="!canEditRecebimento || isAInformar(formData.formaPagamentoId)"
                class="form-control"
              />
            </div>
          </div>

          <!-- Conta Financeira -->
          <div class="col-md-4">
            <div class="form-group">
              <label>
                Conta Financeira
                <span
                  v-if="!isAInformar(formData.formaPagamentoId)"
                  class="required"
                >*</span>
              </label>
              <select
                v-model.number="formData.contaFinanceiraId"
                class="form-control"
                :disabled="isAInformar(formData.formaPagamentoId)"
                :required="!isAInformar(formData.formaPagamentoId)"
              >
                <option value="">Selecione</option>
                <option
                  v-for="c in contasFinanceiras"
                  :key="c.id"
                  :value="c.id"
                >{{ c.texto }}</option>
              </select>
            </div>
          </div>

          <!-- Autorização (Cartão) -->
          <div class="col-md-4" v-if="isCartao(formData.formaPagamentoId)">
            <div class="form-group">
              <label>Autorização <span class="required">*</span></label>
              <input
                type="text"
                v-model="formData.numeroAutorizacao"
                class="form-control"
                placeholder="Número da autorização"
                :disabled="isAInformar(formData.formaPagamentoId)"
              />
            </div>
          </div>

        </div>


        <!-- Observações -->
        <div class="form-group mb-3">
          <label for="observacoes">Observações:</label>
          <textarea id="observacoes" v-model="formData.observacoes" class="form-control" rows="3"></textarea>
        </div>

        <!-- Ações -->
        <div class="d-flex justify-content-end mt-4 mb-4">
          <button class="btn btn-secondary me-2" @click="cancel">Cancelar</button>
          <button class="btn btn-primary" :disabled="!formValid" v-if="hasPermission('alterar_receitas_planos')" @click="save">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useReceitasPermissions } from '@/composables/useReceitasPermissions';
import { ref, reactive, computed, onMounted, watch, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import { loadOperationalAccounts } from '@/services/operationalAccounts';
import globalUtils from '@/utils/globalUtils.js';

export default {
  name: 'EditarReceitasPlanos',
  props: {
    id: { type: [String, Number], required: true }
  },
  setup(props, { emit }) {
    const { fetchPermissions, hasPermission, authorizeReceiptAction } = useReceitasPermissions();

    const instance = getCurrentInstance();
    const gp = instance?.appContext.config.globalProperties;

    const pendentes = ref([]);
    const pendentesTotal = computed(() => (pendentes.value || []).length);

    const aplicarTodosPendentes = ref(false);
    const aplicarValorTambem = ref(false);

    const eraPendenteAoAbrir = ref(false);

    const valorOriginalNum = ref(0);

    // modo do lote:
    // - 'mesma_data' => aplica data_pagamento/data_recebimento iguais para todos
    // - 'sequencial' => base + meses (somente cartão)
    const modoLote = ref('mesma_data');

    // valor original em string BR para comparar (melhor UX)
    const valorOriginalBr = ref('0,00');
    const valorFoiAlterado = computed(() => {
      const atual = parseFloat(String(editingValor.value || '').replace(/\./g, '').replace(',', '.'));
      const atualNum = Number.isFinite(atual) ? atual : 0;
      return atualNum !== (Number(valorOriginalNum.value) || 0);
    });

    const formData = reactive({
      formaPagamentoId: '',
      valor: '',
      dataPagamento: '',
      dataRecebimento: '',
      contaFinanceiraId: null,
      numeroAutorizacao: null,   // ✅ novo
      observacoes: '',
      bancoNumero: '',
      agencia: '',
      chequeNumero: ''
    });

    const loteBloqueado = computed(() => isCheque(formData.formaPagamentoId));

    const showLoteBox = computed(() =>
      eraPendenteAoAbrir.value && pendentesTotal.value > 1 && !loteBloqueado.value
    );

    const canEditRecebimento = computed(() => {
      // 1) via lista de permissões
      const perms = gp?.$globalState?.userPermissions;
      const hasAdminPerm = Array.isArray(perms)
        ? perms.map(s => String(s).toLowerCase().trim()).includes('administrador')
        : false;

      // 2) via perfil/role (string ou objeto)
      const rawProfile = gp?.$globalState?.userProfile;
      const profileStr = typeof rawProfile === 'string'
        ? rawProfile
        : (rawProfile?.perfil ?? rawProfile?.role ?? gp?.$globalState?.role ?? '');
      const isAdminByTitle = /(^|\s)(administrador|admin)(\s|$)/i.test(String(profileStr).trim());

      // 3) flag booleana opcional
      const isAdminFlag = !!gp?.$globalState?.isAdmin;

      return hasAdminPerm || isAdminByTitle || isAdminFlag;
    });

    const contaPadraoGlobalId = computed(() => {
      const c = (contasFinanceiras.value || []).find(x => x.conta_padrao);
      return c?.id ?? null;
    });

    const getFormaById = (id) => (formas.value || []).find(f => Number(f.id) === Number(id));

    const isCartao = (formaId) => norm(getFormaById(formaId)?.nome).includes('cartao');
    const isCartaoCredito = (formaId) => {
      const n = norm(getFormaById(formaId)?.nome);
      return n.includes('cartao') && n.includes('credito');
    };

    // por forma -> fallback global (exceto espécie/a informar)
    const aplicarContaPadraoSeVazio = (formaId) => {
      const forma = getFormaById(formaId);
      if (!forma) return;

      const nome = norm(forma.nome);
      if (nome === 'especie' || nome.includes('informar')) return;

      if (formData.contaFinanceiraId != null && formData.contaFinanceiraId !== '') return;

      const porForma = forma.conta_financeira_padrao_id ? Number(forma.conta_financeira_padrao_id) : null;
      if (porForma) { formData.contaFinanceiraId = porForma; return; }

      if (contaPadraoGlobalId.value) formData.contaFinanceiraId = contaPadraoGlobalId.value;
    };

    const hydrating = ref(true);

    const registro = reactive({
      alunoNome: '',
      matriculaId: null,
      dataVencimento: ''
    });
    const formas = ref([]);
    const contasFinanceiras = ref([]);


    const editingValor = ref('');

    const norm = s => (s ?? '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim().toLowerCase();

    const idBrinde = computed(() =>
      (formas.value || []).find(f => norm(f.nome) === 'brinde')?.id ?? null
    );

    const valorOriginal = ref(0);

    // Computed para formatar e parsear o valor corretamente
    const valorFormatted = computed({
      get() {
        const num = parseFloat(formData.valor);
        return isNaN(num)
          ? ''
          : num.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
      },
      set(val) {
        // remove pontos de milhar e troca vírgula por ponto
        const raw = val.replace(/\./g, '').replace(',', '.');
        formData.valor = raw;
      },
    });


    const loadData = async () => {
      // Carrega registro do back
      const res = await axios.get(`/financeiro/receitas-planos/${props.id}`);
      const d = res.data || {};

      eraPendenteAoAbrir.value = (d.data_pagamento === null || d.data_pagamento === '' || d.data_pagamento === undefined);

      // --- helpers locais ---
      const toDate = (v) => (v ? String(v).split('T')[0] : '');
      const toNumOrNull = (v) => {
        if (v === '' || v === undefined || v === null) return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };

      // --- registro (readonly) ---
      const matriculaIdNum = d.matricula_id != null ? Number(d.matricula_id) : null;

      // descricao vem como "123 - Nome Aluno" (mantemos para exibir nome)
      const desc = String(d.descricao || '');
      const parts = desc.split(' - ');
      const matIdFromDesc = (parts[0] || '').trim();
      const alunoNome = parts.slice(1).join(' - ').trim();

      Object.assign(registro, {
        alunoNome: alunoNome || '',
        matriculaId: Number.isFinite(matriculaIdNum) ? matriculaIdNum : (matIdFromDesc ? Number(matIdFromDesc) : null),
        plano_contas: d.plano_contas || '',
        dataVencimento: toDate(d.data_vencimento)
      });

      // --- formData editável ---
      Object.assign(formData, {
        formaPagamentoId: toNumOrNull(d.forma_pagamento_id),
        dataPagamento: toDate(d.data_pagamento),
        dataRecebimento: toDate(d.data_recebimento),
        contaFinanceiraId: toNumOrNull(d.conta_financeira_id),
        numeroAutorizacao: (d.numero_autorizacao ?? null), // ✅ novo (se vier do back)
        observacoes: d.observacoes ?? '',
        bancoNumero: d.banco_numero ?? '',
        agencia: d.agencia ?? '',
        chequeNumero: d.cheque_numero ?? ''
      });

      // --- valor / máscara ---
      const rawVal = Number(d.valor);
      valorOriginal.value = Number.isFinite(rawVal) ? rawVal : 0;

      // se veio Brinde, força 0 na exibição (regra do componente)
      const isBr = (formData.formaPagamentoId != null && formData.formaPagamentoId === idBrinde.value);
      const valToShow = isBr ? 0 : valorOriginal.value;

      valorOriginalNum.value = Number(valToShow) || 0;

      formData.valor = valToShow; // mantém o número no model
      editingValor.value = Number(valToShow).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      valorOriginalBr.value = editingValor.value;

      // Se data_recebimento veio vazia, mas existe data_pagamento e forma, você pode opcionalmente calcular
      // (eu deixei DESLIGADO para não sobrescrever o que o back entende como correto)
      // if (!formData.dataRecebimento && formData.dataPagamento && formData.formaPagamentoId && !isAInformar(formData.formaPagamentoId)) {
      //   formData.dataRecebimento = globalUtils.calcularDataRecebimento(formData.dataPagamento, formData.formaPagamentoId, formas.value) || '';
      // }
    };


    const loadFormas = async () => {
      const res = await axios.get('/cadastros/formas-pagamento');
      const lista = res.data.data || res.data || [];

      const norm = s => (s ?? '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .trim().toLowerCase();

      const ordemPersonalizada = {
        'pix': 1,
        'especie': 2,
        'cartao de credito a vista': 3,
        'cartao de credito parcelado': 4,
        'cartao de debito': 5,
        'boleto': 6,
        'transferencia bancaria': 7,
        'cheque': 8,
        'a informar': 9,
      };

      formas.value = (Array.isArray(lista) ? lista : [])
        .filter(f => norm(f.nome) !== 'brinde')
        .map(f => ({
          ...f,
          id: Number(f.id),
          conta_financeira_padrao_id: f.conta_financeira_padrao_id != null
            ? Number(f.conta_financeira_padrao_id)
            : null
        }))
        .sort((a, b) => {
          const oa = ordemPersonalizada[norm(a.nome)] ?? 999;
          const ob = ordemPersonalizada[norm(b.nome)] ?? 999;

          if (oa !== ob) return oa - ob;
          return a.nome.localeCompare(b.nome, 'pt-BR');
        });
    };

    const isCheque = id => {
      const f = formas.value.find(f => f.id === id);
      return f ? f.nome.toLowerCase() === 'cheque' : false;
    };

    const isAInformar = id => {
      const f = formas.value.find(f => f.id === id);
      return f ? f.nome.toLowerCase() === 'a informar' : false;
    };

    const formValid = computed(() => {
      if (!formData.formaPagamentoId) return false;

      const fp   = formData.formaPagamentoId;
      const isInf = isAInformar(fp);

      if (!isInf && !formData.dataPagamento) return false;

      // Agora exige conta para qualquer forma que NÃO seja "A informar"
      if (!isInf && (formData.contaFinanceiraId == null)) {
        return false;
      }

      if (isCheque(fp)) {
        if (!(formData.bancoNumero && formData.agencia && formData.chequeNumero)) {
          return false;
        }
      }

      if (isCartao(formData.formaPagamentoId)) {
        if (!(formData.numeroAutorizacao || '').trim()) return false;
      }

      return true;
    });

    function addMonthsISO(baseISO, monthsToAdd) {
      // baseISO: "YYYY-MM-DD"
      const [y, m, d] = String(baseISO).split('-').map(Number);
      const dt = new Date(y, (m - 1), d);

      dt.setMonth(dt.getMonth() + Number(monthsToAdd || 0));

      const yyyy = dt.getFullYear();
      const mm = String(dt.getMonth() + 1).padStart(2, '0');
      const dd = String(dt.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }

    const previewSequencial = computed(() => {
      const fp = formData.formaPagamentoId;
      if (!aplicarTodosPendentes.value) return [];
      if (!isCartaoCredito(fp)) return [];
      if (modoLote.value !== 'sequencial') return [];
      if (!formData.dataPagamento) return [];

      // ordena como no save
      const lista = [...(pendentes.value || [])].sort((a, b) => {
        const da = String(a.data_vencimento || '');
        const db = String(b.data_vencimento || '');
        if (da < db) return -1;
        if (da > db) return 1;
        const pa = String(a.plano_contas || '');
        const pb = String(b.plano_contas || '');
        if (pa < pb) return -1;
        if (pa > pb) return 1;
        return Number(a.id) - Number(b.id);
      });

      return lista.slice(0, 3).map((p, idx) => {
        const pag = addMonthsISO(formData.dataPagamento, idx);
        const rec = globalUtils.calcularDataRecebimento(pag, fp, formas.value) || '';
        return {
          idx: idx + 1,
          pag: formatDateBR(pag),
          rec: rec ? formatDateBR(rec) : null,
        };
      });
    });

    let initialPayload = null;
    const save = async () => {
      if (!initialPayload) return;
      if (!await authorizeReceiptAction('alterar_receitas_planos')) return;
      const num = parseFloat(editingValor.value.replace(/\./g, '').replace(',', '.'));
      const fp = formData.formaPagamentoId;

      const payloadBase = {
        forma_pagamento_id: formData.formaPagamentoId,
        conta_financeira_id: isAInformar(fp) ? null : (formData.contaFinanceiraId || null),
        data_pagamento: formData.dataPagamento || null,
        data_recebimento: formData.dataRecebimento || null,
        observacoes: formData.observacoes,
        banco_numero: formData.bancoNumero,
        agencia: formData.agencia,
        cheque_numero: formData.chequeNumero,
        numero_autorizacao: (formData.numeroAutorizacao || '').trim() || null,
      };

      // Não devolva campos ocultos/inalterados como vazios: preserve os dados bancários.
      for (const key of Object.keys(payloadBase)) {
        if (payloadBase[key] === initialPayload[key]) delete payloadBase[key];
      }

      // valor calculado (só entra no lote se usuário marcar)
      const valorCalc = (fp === idBrinde.value) ? 0 : (isNaN(num) ? 0 : num);

      try {
        const mid = Number(registro.matriculaId);

        // ====== LOTE (somente se usuário marcou e é um registro originalmente pendente) ======
        if (aplicarTodosPendentes.value && eraPendenteAoAbrir.value && pendentesTotal.value > 1) {

          // 5.1) LOTE SEQUENCIAL (somente cartão + modo sequencial)
          if (isCartaoCredito(fp) && modoLote.value === 'sequencial') {
            if (!formData.dataPagamento) {
              gp?.$toast?.error?.('Informe a data de pagamento.');
              return;
            }

            // Ordena por vencimento asc (mesmo que o back já mande, garantimos aqui)
            const lista = [...(pendentes.value || [])].sort((a, b) => {
              const da = String(a.data_vencimento || '');
              const db = String(b.data_vencimento || '');
              if (da < db) return -1;
              if (da > db) return 1;
              // desempate: plano_contas e id
              const pa = String(a.plano_contas || '');
              const pb = String(b.plano_contas || '');
              if (pa < pb) return -1;
              if (pa > pb) return 1;
              return Number(a.id) - Number(b.id);
            });

            const updates = lista.map((p, idx) => {
              const dataPagamento = addMonthsISO(formData.dataPagamento, idx);

              // calcula recebimento com a regra existente
              let dataRecebimento = globalUtils.calcularDataRecebimento(
                dataPagamento,
                fp,
                formas.value
              ) || '';

              // mantém sua exceção de espécie (por garantia)
              if (isEspecie(fp)) dataRecebimento = dataPagamento;

              return {
                id: Number(p.id),
                plano_contas: p.plano_contas,
                data_pagamento: dataPagamento,
                data_recebimento: dataRecebimento || null
              };
            });

            const payloadSequencial = {
              forma_pagamento_id: payloadBase.forma_pagamento_id,
              conta_financeira_id: payloadBase.conta_financeira_id,
              numero_autorizacao: payloadBase.numero_autorizacao,
              observacoes: payloadBase.observacoes,
              banco_numero: payloadBase.banco_numero,
              agencia: payloadBase.agencia,
              cheque_numero: payloadBase.cheque_numero,

              ...(aplicarValorTambem.value ? { valor: valorCalc } : {}),

              updates
            };

            await axios.put(`/financeiro/receitas-planos/pendentes-por-matricula/${mid}/sequencial`, payloadSequencial);
            emit('updated');
            return;
          }

          // 5.2) LOTE SIMPLES (mesma data para todos)
          const payloadLoteSimples = {
            ...payloadBase,
            ...(aplicarValorTambem.value ? { valor: valorCalc } : {})
          };

          await axios.put(`/financeiro/receitas-planos/pendentes-por-matricula/${mid}`, payloadLoteSimples);
          emit('updated');
          return;
        }

        // ====== UNITÁRIO ======
        const payloadSingle = {
          ...payloadBase,
          ...(valorCalc !== initialPayload.valor ? { valor: valorCalc } : {})
        };
        if (!Object.keys(payloadSingle).length) {
          emit('updated');
          return;
        }

        await axios.put(`/financeiro/receitas-planos/${props.id}`, payloadSingle);
        emit('updated');
      } catch (e) {
        console.error('Erro ao salvar receita:', e);
        gp?.$toast?.error?.('Erro ao salvar receita');
      }
    };

    const idEspecie = computed(() =>
      formas.value.find(f => f.nome.toLowerCase()==='espécie')?.id || null
    );
    function isEspecie(id) {
      return id === idEspecie.value;
    }

    function formatDateBR(iso) {
      if (!iso) return '';
      const [y, m, d] = String(iso).split('-');
      if (!y || !m || !d) return String(iso);
      return `${d}/${m}/${y}`;
    }


    async function loadPendentesMatricula() {
      const mid = Number(registro.matriculaId);
      if (!Number.isFinite(mid) || mid <= 0) {
        pendentes.value = [];
        return;
      }

      const res = await axios.get(`/financeiro/receitas-planos/pendentes-por-matricula/${mid}`);
      pendentes.value = res.data?.data || [];
    }

    // carregar contas financeiras
    async function loadContas() {
      contasFinanceiras.value = await loadOperationalAccounts('receita_plano_edicao');
    }

    // // helper pra interpretar "1.234,56" ou "1234.56"
    // const parseBR = (s) => {
    //   if (s == null) return 0;
    //   const raw = String(s).replace(/\./g, '').replace(',', '.');
    //   const n = Number(raw);
    //   return Number.isFinite(n) ? n : 0;
    // };

    watch(loteBloqueado, (bloqueado) => {
      if (bloqueado) {
        aplicarTodosPendentes.value = false;
        aplicarValorTambem.value = false;
        modoLote.value = 'mesma_data';
      }
    });

    // Quando o usuário marcar "aplicar a todos", define um default coerente
    watch(aplicarTodosPendentes, (on) => {
      if (!on) {
        modoLote.value = 'mesma_data';
        // não mexo em aplicarValorTambem
        return;
      }

      if (isCartaoCredito(formData.formaPagamentoId)) {
        modoLote.value = 'sequencial';
      } else {
        modoLote.value = 'mesma_data';
      }
    });

    watch(
      () => formData.formaPagamentoId,
      (nova) => {
        if (!aplicarTodosPendentes.value) return;

        if (isCartaoCredito(nova)) {
          modoLote.value = 'sequencial';
        } else {
          modoLote.value = 'mesma_data';
        }
      }
    );

    // Se por qualquer motivo o box do lote sumir, zera estados do lote
    watch(showLoteBox, (ok) => {
      if (!ok) {
        aplicarTodosPendentes.value = false;
        aplicarValorTambem.value = false;
        modoLote.value = 'mesma_data';
      }
    });

    watch(
      [() => formData.dataPagamento, () => formData.formaPagamentoId],
      ([dataPag, formaId]) => {
        if (hydrating.value) return; // ← não recalcula ao montar com valores do backend
        if (!formaId || isAInformar(formaId)) {
          formData.dataRecebimento = '';
          return;
        }
        if (!dataPag) {
          formData.dataRecebimento = '';
          return;
        }
        if (isEspecie(formaId)) {
          formData.dataRecebimento = dataPag; // espécie/PIX/cheque/transferência etc. já tratados em calcularDataRecebimento também
          return;
        }
        formData.dataRecebimento = globalUtils.calcularDataRecebimento(
          dataPag,
          formaId,
          formas.value
        ) || '';
      },
      { immediate: true }
    );

    watch(
      () => formData.formaPagamentoId,
      (nova, antiga) => {
        if (hydrating.value) return;
        if (nova === antiga) return;

        formData.contaFinanceiraId = null;
        formData.numeroAutorizacao = null;

        // se saiu de cheque: limpa campos
        if (antiga && !isCheque(nova)) {
          formData.bancoNumero = '';
          formData.agencia = '';
          formData.chequeNumero = '';
        }

        const isInf = isAInformar(nova);
        const isBr  = (nova === idBrinde.value);

        if (isInf) {
          formData.dataPagamento = '';
          formData.dataRecebimento = '';
          formData.contaFinanceiraId = null;
          return;
        }

        if (isEspecie(nova)) {
          // não aplica conta padrão
          return;
        }

        // demais formas: tenta conta padrão (por forma -> fallback global)
        aplicarContaPadraoSeVazio(nova);

        // Brinde: seu bloco atual pode continuar (zerar valor etc.)
        if (isBr) {
          formData.valor = 0;
          editingValor.value = (0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return;
        }

        // Saiu de Brinde → restaura original
        if (antiga === idBrinde.value) {
          const n = Number(valorOriginal.value) || 0;
          formData.valor = n;
          editingValor.value = n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return;
        }

        // Troca entre formas não-Brinde → mantém valor atual como novo original
        const n = Number(String(editingValor.value).replace(/\./g,'').replace(',','.')) || 0;
        valorOriginal.value = n;
        formData.valor = n;
      }
    );

    const cancel = () => emit('cancel');

    onMounted(async () => {
      await fetchPermissions();
      await loadFormas();
      await loadContas();
      await loadData();

      await loadPendentesMatricula();

      // se só existir 1 pendente, não deixa marcado
      if (pendentesTotal.value <= 1) {
        aplicarTodosPendentes.value = false;
      }

      initialPayload = {
        valor: Number(formData.valor),
        forma_pagamento_id: formData.formaPagamentoId,
        conta_financeira_id: isAInformar(formData.formaPagamentoId) ? null : (formData.contaFinanceiraId || null),
        data_pagamento: formData.dataPagamento || null,
        data_recebimento: formData.dataRecebimento || null,
        observacoes: formData.observacoes,
        banco_numero: formData.bancoNumero,
        agencia: formData.agencia,
        cheque_numero: formData.chequeNumero,
        numero_autorizacao: (formData.numeroAutorizacao || '').trim() || null,
      };
      hydrating.value = false; // ← a partir daqui os watchers podem recalcular normalmente
    });

    // limpa formatação para edição
    function handleFocusValor() {
    }
    // reaplica formatação e armazena em formData

    function parseMoneyBR(s) {
      s = String(s ?? '').trim();
      if (!s) return 0;
      return Number(s.replace(/\./g, '').replace(',', '.')) || 0;
    }

    function handleBlurValor() {
      const n = parseMoneyBR(editingValor.value);

      formData.valor = n;

      editingValor.value = n.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      // ✅ NÃO atualizar valorOriginalNum aqui
      // ✅ Se quiser, pode atualizar só valorOriginal (se você usa isso pra brinde etc.)
      if (formData.formaPagamentoId !== idBrinde.value) {
        valorOriginal.value = n; // opcional (pode manter, não afeta o checkbox)
      }
    }

    return { hasPermission,
        contasFinanceiras,
        registro, 
        formas, 
        formData, 
        isCheque, 
        isAInformar,
        isEspecie,
        formValid, 
        save, 
        cancel,
        valorFormatted,
        editingValor,
        handleBlurValor,
        handleFocusValor,
        canEditRecebimento,
        isCartao,
        pendentes,
        pendentesTotal,
        aplicarTodosPendentes,
        aplicarValorTambem,
        showLoteBox,
        valorFoiAlterado,
        modoLote,
        isCartaoCredito,
        loteBloqueado,
        previewSequencial,
        valorOriginalNum,
    };
  }
};
</script>

<style scoped>
/* Ajusta o cabeçalho do modal */
  /* Cabeçalho do modal */
  .modal-header {
    background: #ccc; /* cor cinza */
    padding: 10px 15px; 
    display: flex;
    justify-content: space-between;
    align-items: center;
  }


  /* Estilos gerais do modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .modal-container {
  background: #fff;
  width: 100%;
  max-width: 60%; /* ajuste conforme necessário */
  height: auto; /* define a altura fixa */
  overflow-y: auto; /* adiciona barra de rolagem vertical se necessário */
  margin: 0 10px;
  border-radius: 0px;

  /* Remova margens duplicadas se estiverem interferindo */
}

/* Conteúdo do modal */
.modal-content {
padding: 15px;

}


.modal {
  display: block;
  background: white;
  width: 60%;
  max-width: 90%;
  max-height: 80%;
  overflow-y: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

  /* Ícone de fechar */
  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
  }

/* Espaço semelhante ao utilizado no Formulário */
.spacer {
  margin-bottom: 20px;
}

/* Seções e grupos (estilo do formulário) */
.form-section {
  background: white;
  padding: 15px;
  border-radius: 0px;
  border: 1px solid #dee2e6;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.required {
  color: red;
}


/* Inputs e selects */
.form-control {
  width: 100%;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 0px;
}

/* Ajustes para botões de ação para turmas e pagamentos */
.turma-item,
.table .btn {
  margin-top: 0px;
}

.add-turma-container {
  display: flex;
  justify-content: flex-end; /* Alinha o botão à direita */
  margin-top: 5px; /* Pequeno espaçamento acima */
}

/* Esconde o input nativo */
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}


/* Esconde o input nativo */
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

.spacer {
  margin-bottom: 20px;
}

.btn-warning {
  font-size: 12px;
}

.lote-card {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
}

.lote-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.lote-title {
  font-weight: 600;
  font-size: 0.85rem;
  color: #2563eb;             /* mesmo azul do título */

}

.lote-badge {
  font-size: 0.75rem;
  padding: 2px 8px;
  border-radius: 999px;
  background: #d2c2a7;
  color: #140808;
}

.lote-check {
  display: inline-flex;     /* mais estável que flex em alguns layouts */
  align-items: center;      /* centraliza verticalmente */
  gap: 10px;
  margin-top: 2px;
}

.lote-checkbox {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin: 0 !important;     /* vence bootstrap */
  vertical-align: middle !important;
  transform: translateY(-1px); /* ajuste fino (pode virar 0 ou -2) */
}

.lote-main-label {
  margin: 0;                /* remove default */
  line-height: 1;           /* evita o label “descer” */
  display: inline-block;
  font-weight: 200;         /* teu 200 deixa “fraco” */
  font-size: 0.85rem;       /* pra casar com o título */
  color: #2563eb;
  cursor: pointer;
}



.lote-subtext {
  margin-top: 6px;
  font-size: 0.8rem;
  color: #6b7280;
}

.lote-divider {
  height: 1px;
  background: #eef2f7;
  margin: 10px 0;
}

.lote-preview-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.lote-preview-rows {
  display: grid;
  gap: 4px;
}

.lote-preview-row {
  display: grid;
  grid-template-columns: 36px 1fr 18px 1fr;
  align-items: center;
  font-size: 0.8rem;
  color: #374151;
}

.lote-preview-idx {
  color: #6b7280;
}

.lote-preview-arrow {
  text-align: center;
  color: #9ca3af;
}

.lote-warn {
  margin-top: 8px;
  font-size: 0.8rem;
  color: #b45309; /* âmbar discreto */
}
.lote-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 12px;
  background: #fff;
  transition: border 0.2s ease;
  position: relative;
}

/* Faixa lateral quando ativo */
.lote-card--active {
  border-left: 4px solid #2563eb; /* azul elegante */
  padding-left: 12px; /* compensa a faixa */
}

.lote-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}


.lote-preview-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.lote-preview-grid {
  display: grid;
  grid-template-columns: 40px 1fr 1fr;
  gap: 4px 10px;
  font-size: 0.8rem;
  color: #374151;
}

.lote-preview-header {
  font-weight: 600;
  color: #6b7280;
}

.lote-preview-cell {
  padding: 2px 0;
}

.lote-preview-idx {
  color: #6b7280;
}

.lote-body {
  display: grid;
  grid-template-columns: 1fr 360px; /* preview fixo à direita */
  gap: 14px;
  align-items: start;
  margin-top: 8px;
}

.lote-left {
  min-width: 0;
}

.lote-right {
  border-left: 1px solid #eef2f7;
  padding-left: 14px;
}

@media (max-width: 992px) {
  .lote-body {
    grid-template-columns: 1fr; /* empilha no mobile */
  }
  .lote-right {
    border-left: none;
    padding-left: 0;
    margin-top: 10px;
  }
}


</style>
